import * as utils from '../functions/utils';
import { PAYMENT_RESPONSE } from '../constants/constants';

export interface IApiReceiptAmount {
  Total?: number;
  Tax?: number;
  AmountLessTax?: number;
}

export interface IApiPurchaseReceipt {
  Company?: string;
  ABN?: string;
  ReceiptNumber?: string;
  CreditCardNumber?: string;
  Amount?: IApiReceiptAmount;
}

export interface IApiPurchaseResponse {
  PaymentSuccess?: boolean;
  PaymentResponse?: string;
  ErrorCode?: string;
  ErrorMessage?: string;
  Message?: string;
  Receipt?: IApiPurchaseReceipt;
}

class receiptAmount {
  total: number;
  tax: number;
  amountLessTax: number;

  constructor() {
    this.total = 0.0;
    this.tax = 0.0;
    this.amountLessTax = 0.0;
  }

  static mappingPropObjects(_obj: IApiReceiptAmount): receiptAmount {
    let obj = new receiptAmount();
    // utils.formatNumberShowNDecimalPlaces returns string or number? Assuming number based on 0.0 default
    obj.total = (utils as any).formatNumberShowNDecimalPlaces(_obj.Total, 2) || 0.0;
    obj.tax = (utils as any).formatNumberShowNDecimalPlaces(_obj.Tax, 2) || 0.0;
    obj.amountLessTax = (utils as any).formatNumberShowNDecimalPlaces(_obj.AmountLessTax, 2) || 0.0;
    obj = (utils as any).cleanObjectKeys(Object.keys(new receiptAmount()), obj);

    return obj;
  }
}

class purchaseReceipt {
  amount: receiptAmount | null;
  company: string;
  abn: string;
  receiptNumber: string;
  creditCardNumber: string;

  constructor() {
    this.amount = null;
    this.company = '';
    this.abn = '';
    this.receiptNumber = '';
    this.creditCardNumber = '';
  }

  static mappingPropertyObject(_obj: IApiPurchaseReceipt): purchaseReceipt {
    let obj = new purchaseReceipt();
    obj.company = _obj.Company || '';
    obj.abn = _obj.ABN || '';
    obj.receiptNumber = _obj.ReceiptNumber || '';
    obj.creditCardNumber = _obj.CreditCardNumber || '';
    obj.amount = (_obj.Amount && receiptAmount.mappingPropObjects(_obj.Amount)) || null;
    obj = (utils as any).cleanObjectKeys(Object.keys(new purchaseReceipt()), obj);

    return obj;
  }
}

export default class purchaseResponse {
  paymentSuc: boolean;
  paymentRes: string | null;
  errorCode: string;
  errorMess: string;
  receipt: purchaseReceipt | null;
  message: string;
  ccNumber?: string;

  constructor() {
    this.paymentSuc = false;
    this.paymentRes = null;
    this.errorCode = '';
    this.errorMess = '';
    this.receipt = null;
    this.message = '';
  }

  static mappingPropertyObject(_obj: IApiPurchaseResponse): purchaseResponse {
    let obj = new purchaseResponse();
    obj.paymentSuc = (_obj.PaymentSuccess && _obj.PaymentResponse === PAYMENT_RESPONSE.SUCCESS) || false;
    obj.errorCode = _obj.ErrorCode || '';
    // obj.errorMess = _obj.ErrorMessage || _obj.Message || '';
    obj.errorMess =
      _obj.PaymentResponse === PAYMENT_RESPONSE.INSUFFICIENT_FUNDS ? _obj.ErrorMessage || 'Insufficient Funds' : 'Transaction Failed';
    obj.message = _obj.Message || obj.errorMess || '';
    obj.paymentRes = _obj.PaymentResponse || null;
    obj.receipt = (_obj.Receipt && purchaseReceipt.mappingPropertyObject(_obj.Receipt)) || null;
    obj = (utils as any).cleanObjectKeys(Object.keys(new purchaseResponse()), obj);

    return obj;
  }
}
